import React, { useState } from 'react';
import { getApiErrorMessages } from "../utils/apiError";
import { Link, useNavigate, useLocation } from 'react-router-dom';
// import { motion } from 'framer-motion';
import { Eye, EyeOff, Mail, Lock, User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { safeNavigate } from '../utils/navigationUtils';
import logo from '../assets/logo6.png';
// import GradientBackground from '../components/ui/GradientBackground';
import { GoogleLogin } from '@react-oauth/google';
import { t as tr } from '../contexts/translations';


const Login = ({ language }) => {
  const [email, setEmail] = useState('');
  const [mdp, setMdp] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  
  
  const { login, googleLogin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const activeLanguage = language || localStorage.getItem('language') || 'fr';
  const T = (key, fallback) => {
    const v = tr(key, activeLanguage);
    return v === key ? fallback : v;
  };
  
  const handleGoogleSuccess = async (credentialResponse) => {
  try {
    setError('');
    setLoading(true);

    const idToken = credentialResponse.credential;
    await googleLogin(idToken);

    safeNavigate(navigate, from, { replace: true });
  } catch (err) {
    console.error('Erreur Google Login :', err);
    setError(T('googleLoginError', "Échec de la connexion avec Google. Veuillez réessayer."));
  } finally {
    setLoading(false);
  }
};

const handleGoogleError = () => {
  setError(T('googleLoginFailed', "La connexion avec Google a échoué."));
};


  // Récupérer la page de redirection, si elle existe
  const from = location.state?.from || '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setError('');
      setLoading(true);
      
      await login(email, mdp);
      
      // Redirection vers la page d'origine ou la page d'accueil
      safeNavigate(navigate, from, { replace: true });
    } catch (err) {
      console.error('Erreur de connexion:', err);
      setError(getApiErrorMessages(err, T('loginError', 'Échec de connexion. Vérifiez vos identifiants.'))[0]);
    } finally {
      setLoading(false);
    }
  };

  /*
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };
  */

  /*
  const formVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5,
        delay: 0.2,
        ease: "easeOut"
      }
    }
  };
  */

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        {/* Logo and Header */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-6">
            <Link to="/" className="flex items-center group">
              <img 
                src={logo} 
                alt="PalaisTouristiques" 
                className="h-20 w-auto transition-all duration-500"
              />
            </Link>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            {T('loginWelcomeTitle', 'Bon retour !')}
          </h2>
          <p className="text-gray-600">
            {T('loginWelcomeSubtitle', 'Connectez-vous à votre compte pour continuer votre aventure')}
          </p>
        </div>
        
        {/* Main Form Card */}
        <div className="bg-white/80 backdrop-blur-xl rounded-2xl shadow-2xl border border-orange-200/50 p-8">
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl mb-6 flex items-center gap-2">
              <div className="w-2 h-2 bg-red-500 rounded-full"></div>
              <span className="text-sm">{error}</span>
            </div>
          )}

          {/* Bouton Google (centré) */}
<div className="mb-6">
  <div className="w-full flex justify-center">
    <div className="w-full max-w-sm flex justify-center ">
      <GoogleLogin
        onSuccess={handleGoogleSuccess}
        onError={handleGoogleError}
        width="100%"
        size="large"
        theme="outline"
        shape="pill"
        text="continue_with"
      />
    </div>
  </div>

  <div className="mt-6 flex items-center">
    <div className="flex-1 h-px bg-gray-200" />
    <span className="px-3 text-xs text-gray-500 uppercase">{T('or', 'ou')}</span>
    <div className="flex-1 h-px bg-gray-200" />
  </div>
</div>

          
          <form className="space-y-6" onSubmit={handleSubmit}>
            {/* Email Field */}
            <div>
              <label htmlFor="email-address" className="block text-sm font-medium text-gray-700 mb-2">
                {T('emailLabel', 'Adresse email')}
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Mail className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  id="email-address"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-xl placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-300 bg-white/50 backdrop-blur-sm"
                  placeholder="votre@email.com"
                />
              </div>
            </div>
            {/* Password Field */}
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                {T('password', 'Mot de passe')}
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Lock className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  id="password"
                  name="mdp"
                  type={showPassword ? 'text' : 'password'}
                  autoComplete="current-password"
                  required
                  value={mdp}
                  onChange={(e) => setMdp(e.target.value)}
                  className="block w-full pl-10 pr-10 py-3 border border-gray-300 rounded-xl placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-300 bg-white/50 backdrop-blur-sm"
                  placeholder={T('passwordPlaceholder', 'Votre mot de passe')}
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <EyeOff className="h-5 w-5 text-gray-400 hover:text-gray-600" />
                  ) : (
                    <Eye className="h-5 w-5 text-gray-400 hover:text-gray-600" />
                  )}
                </button>
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-semibold rounded-xl text-white bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 hover:scale-[1.02] shadow-lg"
            >
              <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                <User className="h-5 w-5 text-orange-300 group-hover:text-orange-200" />
              </span>
              {loading ? (
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                  {T('loggingIn', 'Connexion en cours...')}
                </div>
              ) : (
                T('loginButton', 'Se connecter')
              )}
            </button>
          </form>

          {/* Register Link */}
          <div className="mt-6 text-center">
            <p className="text-sm text-gray-600">
              {T('noAccountPrompt', 'Pas encore de compte ?')} {' '}
              <Link 
                to="/register" 
                className="font-medium text-orange-600 hover:text-orange-500 transition-colors duration-300"
              >
                {T('createAccount', 'Créer un compte')}
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;